import React from "react";
import { useEffect, useState } from "react";
import { useAuth } from "../Contexts/AuthContext";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../Utilities/LoadSpinner";
import { format } from "date-fns";
import NewManageBookingDetails from "./ManageBookings/NewManageBookingDetails";


const ManagerDashboard = () => {
  const [latestBookings, setLatestBookings] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
    const [selectedOrder, setSelectedOrder] = useState<any | null>(null); 
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  const isAdmin = (() => {
    if (!user) return false;
    const roleClaim = user["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] as
      | string
      | string[]
      | undefined;
    if (Array.isArray(roleClaim)) {
      return roleClaim.includes("Admin") || roleClaim.includes("SuperAdmin");
    }
    return roleClaim === "Admin" || roleClaim === "SuperAdmin";
  })();
const getArrivalDate = (booking: any): Date | null => {
  if (booking.bookings && booking.bookings.length > 0 && booking.bookings[0].arrivalDate) {
    return new Date(booking.bookings[0].arrivalDate);
  }
  return null;
};

// Sort by arrivalDate descending (latest/future first)
const sortedLatestBookings = [...latestBookings].sort((a, b) => {
  const aDate = getArrivalDate(a);
  const bDate = getArrivalDate(b);

  if (!aDate && !bDate) return 0;
  if (!aDate) return 1;
  if (!bDate) return -1;

  return bDate.getTime() - aDate.getTime(); // Descending: latest first
});

  useEffect(() => {
    const fetchLatestBookings = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        console.log("Access Token:", accessToken);

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/Booking/latestBookings`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );

        console.log("Latest bookings response:", response);
        const data = response.data as { data: any[] }; // Define the expected type
        setLatestBookings(data.data); // Access the data property
        setLoading(false);
      } catch (error) {
        console.error("Error fetching latest bookings:", error);
        setLoading(false);
      }
    };

    fetchLatestBookings();
  }, []);

  if (!isAuthenticated) {
    navigate("/login");
  }

  return (
    <>
      <section className="manager-dashboard">
        <div className="dashboard-sections">
          {/* <Link to="/campsites" className="dashboard-section">
            Campsite Manager
          </Link> */}
          <Link to="/managerCalendarView" className="dashboard-section">
            Calendar Manager
          </Link>
          <Link to="/newPackageManager" className="dashboard-section">
            Package Manager
          </Link>
          <Link to="/businessUserManager" className="dashboard-section">
            Manage Tour Operators
          </Link>
          <Link to="/privateUserManager" className="dashboard-section">
            Manage Private Users
          </Link>
          <Link to="/bookingManager" className="dashboard-section">
            Booking Manager
          </Link>
          <Link to="/categoryManager" className="dashboard-section">
            Category Manager
          </Link>
          <Link to="/chaletBookingLookup" className="dashboard-section">
            Chalet Booking Lookup
          </Link>
          <Link to="/debug-availability" className="dashboard-section" style={{ backgroundColor: '#dc3545', color: 'white' }}>
            🔧 Debug Availability
          </Link>
          {isAdmin && (
            <Link to="/adminDiagnostics" className="dashboard-section">
              Diagnostics (Admin)
            </Link>
          )}
        </div>
    
    <div className="latest-bookings">
          <h2>Latest Bookings</h2>
          {loading ? (
            <LoadingSpinner />
          ) : selectedOrder ? (
            <NewManageBookingDetails
              order={selectedOrder}
              onEdit={() => {}} // Provide if needed
              onClose={() => setSelectedOrder(null)}
              fetchBookings={() => {}} // Provide if needed
            />
          ) : (
            <div className="booking-dashboard-list">
              <div className="list-header">
                <span>Order Number</span>
                <span>Created At</span>
                <span>Customer</span>
                <span>Package</span>
                <span>Arrival Date</span>
                <span>Departure Date</span>
                <span>Actions</span>
              </div>
              <ul className="list-group">
                {sortedLatestBookings.map((booking) => (
                  <li key={booking.orderNumber} className="list-group-item">
                    <div className="booking-field orderNumber">
                      {booking?.orderNumber}
                    </div>
                    <div className="booking-field createdAt">
                      {format(
                        new Date(Date.parse(booking?.createdAt)),
                        "yyyy-MM-dd"
                      )}
                    </div>
                    <div className="booking-field customer">
                      {booking?.customerName}
                    </div>
                    {booking.bookings &&
                      booking.bookings.map((subBooking: any) => (
                        <React.Fragment key={subBooking.bookingId}>
                          <div className="booking-field campsite">
                            {subBooking?.packageName}
                          </div>
                          <div className="booking-field arrivalDate">
                            {format(
                              new Date(Date.parse(subBooking?.arrivalDate)),
                              "yyyy-MM-dd"
                            )}
                          </div>
                          <div className="booking-field departureDate">
                            {format(
                              new Date(Date.parse(subBooking?.departureDate)),
                              "yyyy-MM-dd"
                            )}
                          </div>
                        </React.Fragment>
                      ))}
                    <div className="booking-field actions">
                      <button
                        className="btn btn-sm btn-outline-info me-2"
                        onClick={() => setSelectedOrder(booking)}
                      >
                        <i className="fas fa-eye"></i> View
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ManagerDashboard;
